import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tabs,
} from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { findLodash, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import { addEmployees, updateEmployees } from "./../../../../actions/employees";
import { APP_BASE_URL } from "./../../../../config/Axios";
import "./../userControl.css";
import moment from "moment";

const { TabPane } = Tabs;
const { Option } = Select;

// const columns = [
//   {
//     title: "Category",
//     dataIndex: "nasme",
//     key: "nasme",
//   },
//   {
//     title: "Limit Duration",
//     dataIndex: "accodunt_code",
//     key: "account_codsxde",
//   },
//   {
//     title: "Amount",
//     dataIndex: "is_bifdll_mandatory",
//     key: "is_bill_mfdandatory",
//   },
//   {
//     title: "Eligible Amount",
//     dataIndex: "account_code",
//     key: "account_code",
//   },
// ];

const ValidationSchema = yup.object().shape({
  // name: yup
  //     .string()
  //     .required('Please provide Name'),
  // email: yup
  //     .string()
  //     .email()
  //     .required('Please provide valid email'),
  // primary_phone: yup
  //     .string()
  //     .matches(phoneRegExp, 'Phone number is not valid'),
});

/* eslint-disable no-template-curly-in-string */
const validateMessages1 = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
};
/* eslint-enable no-template-curly-in-string */

const AddUsers = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = React.useState("profile");
  const [checkedValue, setCheckedValue] = React.useState(true);
  const [payloadPage1, setPayloadPage1] = React.useState({});
  const [payloadPage2, setPayloadPage2] = React.useState({});
  const [payloadPage3, setPayloadPage3] = React.useState({});
  const [mobile, setMobile] = React.useState("");
  const [gradesData, setGradesData] = React.useState([]);
  const [role, setRole] = React.useState([]);
  const [sameAsPermanent, setSameAsPermanent] = React.useState(false);

  const projectsResponse = useSelector(
    (state) =>
      state.companySetting.getProjectsField?.data?.response?.projects || [],
  );
  const addEmployeesResponse = useSelector(
    (state) => state.employees.addEmployees || {},
  );

  const updateEmployeesResponse = useSelector(
    (state) => state.employees.updateEmployees || {},
  );
  const costCentersResponse = useSelector(
    (state) =>
      state.companySetting.getCostCenterField?.data?.response?.costcenters ||
      [],
  );
  const employeesResponse = useSelector(
    (state) => state.employees.employees || {},
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {},
  );
  const userFieldsResponse = useSelector(
    (state) => state.companySetting.getCustomFields || {},
  );
  const getDesignationsResponse = useSelector(
    (state) => state.companySetting.getDesignations || {},
  );
  const { data: { response: { roles: rolesData = [] } = {} } = {} } =
    rolesResponse;
  const {
    data: {
      response: {
        custom_fields: userfieldsData = [],
        report_approvers: approversData = [],
        advance_approvers: advanceApproversData = [],
      } = {},
    } = {},
  } = userFieldsResponse;

  const {
    data: { response: { designations: designationsData = [] } = {} } = {},
  } = getDesignationsResponse;
  const editValues =
    findLodash(employeesResponse?.data?.response?.employees, {
      id: props.selectedId,
    }) || {};

  React.useEffect(() => {
    if (employeesResponse.success && props.selectedId) {
      form.resetFields();

      let obj = {};
      approversData.forEach((ele) => {
        obj[ele.name] = ele?.selected?.id ?? "";
      });
      userfieldsData.forEach((ele) => {
        obj[ele.field_id] = ele?.selected?.id ?? "";
      });
      if (editValues?.designation?.id) {
        handleDesignation(editValues?.designation?.id);
      }
      form.setFieldsValue({
        title: editValues?.title,
        address_line_1: editValues?.address_line_1,
        address_line_2: editValues?.address_line_2,
        address_line_3: editValues?.address_line_3,
        communication_address_line_1: editValues?.communication_address_line_1,
        communication_address_line_2: editValues?.communication_address_line_2,
        communication_address_line_3: editValues?.communication_address_line_3,
        communication_city: editValues?.communication_city,
        communication_state: editValues?.communication_state,
        communication_pincode: editValues?.communication_pincode,
        kyc_type: editValues?.kyc_type,
        kyc_method: editValues?.kyc_method,
        ovd_type: editValues?.ovd_type,
        ovd_details: editValues?.ovd_details,
        city: editValues?.city,
        pincode: editValues?.pincode,
        state: editValues?.state,
        dob: editValues?.dob ? moment(editValues?.dob, "DD-MM-YYYY") : "",
        nationality: editValues?.nationality,
        source_of_income: editValues?.source_of_income,
        gender: editValues?.gender,
        name: editValues?.name,
        first_name: editValues?.first_name,
        middle_name: editValues?.middle_name,
        last_name: editValues?.last_name,
        email: editValues?.email,
        primary_phone: editValues?.primary_phone,
        emp_id: editValues?.emp_id,
        roles: editValues?.roles,
        department: editValues?.department,
        occupation: editValues?.occupation,
        approver: editValues?.user_id,
        project_id: editValues?.project?.id,
        cost_center_id: editValues?.cost_center?.id,
        designation: editValues?.designation?.id,
        grade_id: editValues?.grade?.id,
        source_income_type: editValues?.source_income_type,
        // annual_income: editValues?.annual_income,
        customer_type: editValues?.customer_type,
        political_exposed_person: editValues?.political_exposed_person,
        fatca_declaration: editValues?.fatca_declaration,
        pan: editValues?.pan,
        ...obj,
      });
      setMobile(editValues?.primary_phone);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approversData, userfieldsData]);

  const handleBackButton = (goto) => {
    switch (goto) {
      case "screen1":
        setActiveTab("profile");
        break;
      case "screen2":
        setActiveTab("limits");
        break;
      default:
        break;
    }
  };

  const changeTab = (activeKey) => {
    const page1 = {};
    const page2 = {};
    //   const page3 = {};
    if (activeKey === "limits") {
      [
        "title",
        "first_name",
        "middle_name",
        "last_name",
        "email",
        "dob",
        "primary_phone",
        "roles",
        "emp_id",
        "gender",
        "nationality",
        "occupation",
        "address_line_1",
        "address_line_2",
        "address_line_3",
        "city",
        "pincode",
        "state",
        "communication_address_line_1",
        "communication_address_line_2",
        "communication_address_line_3",
        "communication_city",
        "communication_state",
        "communication_pincode",
        "kyc_type",
        "kyc_method",
        "ovd_type",
        "ovd_details",
        "custom_fields",
        "approver",
        "pan",
      ].forEach((item) => {
        page1[item] = form.getFieldValue(item) ? form.getFieldValue(item) : "";
      });
      // page1.name = page1.first_name + " " +" " + page1.last_name;
      page1.name = `${page1.first_name} ${
        page1.middle_name ? page1.middle_name + " " : ""
      }${page1.last_name}`;
      const fieldValues = userfieldsData.map(({ field_id, column_name }) => {
        let id = field_id;
        let value = form.getFieldValue(field_id)
          ? form.getFieldValue(field_id)
          : "";
        let field_name = column_name;
        return { id, value, field_name };
      });

      const approversDataSet = approversData
        .map(({ name, role_id }) => {
          return form.getFieldValue(name)
            ? { role_id: role_id, approver_id: form.getFieldValue(name) }
            : false;
        })
        .filter((ele) => ele);
      const advanceApproversDataSet = advanceApproversData.map(({ name }) => {
        return form.getFieldValue(name);
      });

      page1["field_values"] = fieldValues.filter(Boolean) || [];
      page1["report_approvers"] = approversDataSet.filter(Boolean) || [];
      page1["advance_approvers"] =
        advanceApproversDataSet.filter(Boolean) || [];

      ValidationSchema.validate(page1)
        .then(function () {
          setPayloadPage1(page1);
          setActiveTab(activeKey);
        })
        .catch(function (err) {});
    } else if (activeKey === "card") {
      ["designation", "grade_id"].forEach((item) => {
        page2[item] = form.getFieldValue(item);
      });

      setPayloadPage2(page2);
      setActiveTab(activeKey);
    }
  };

  const tabTitle = {
    profile: () => {
      return (
        <>
          <div className="tabCircles">1</div>
          <div className="tabTitles">
            Profile<p>User&apos;s Personal Information</p>
          </div>
        </>
      );
    },
    limits: () => {
      return (
        <>
          <div className="tabCircles">2</div>
          <div className="tabTitles">
            Grades & Designations<p>Define Grades & Designations for User</p>
          </div>
        </>
      );
    },
    card: () => {
      return (
        <>
          <div className="tabCircles">3</div>
          <div className="tabTitles">
            Card<p>Assign Prepaid Card</p>
          </div>
        </>
      );
    },
  };

  useEffect(() => {
    form.setFieldsValue({
      nationality: "Indian",
      customer_type: "Individual",
      source_of_income: "Salaried",
      // source_income_type: "salary",
      card_number: props.user?.card_reference_no,
    });
  }, []);

  // const data = [];

  const handleSubmit1 = () => {
    changeTab("limits");
  };

  const handleSubmit2 = () => {
    changeTab("card");
  };

  const handleSubmit3 = () => {
    const page3 = {};
    changeTab("submit");
    ["card_number"].forEach((item) => {
      payloadPage3[item] = form.getFieldValue(item);
      page3[item] = form.getFieldValue(item);
    });

    setPayloadPage3(page3);

    const subObj = { ...payloadPage1, ...payloadPage2, ...payloadPage3 };
    subObj.dob = subObj.dob.format("DD-MM-YYYY");

    if (subObj) {
      Object.keys(subObj).forEach((key) => {
        if (key === "emp_id") {
        } else if (!subObj[key]) {
          delete subObj[key];
        }
      });
      props.selectedId
        ? dispatch(
            updateEmployees(
              objectToFormData({ ...subObj, id: props.selectedId }),
            ),
          )
        : dispatch(
            addEmployees(
              objectToFormData({ ...subObj, redirect_url: APP_BASE_URL }),
            ),
          );
    }
  };

  const handleDesignation = (value) => {
    const gradesValue = findLodash(designationsData, { id: value })?.grades;
    setGradesData(gradesValue);
    form.setFields([
      {
        name: "grade_id",
        value: "",
      },
    ]);
  };

  const handleCheck = (e) => {
    setCheckedValue(e.target.checked);
  };

  const VALID_ANNUAL_INCOME = [
    "Rs. 0.00 Lacs - Rs. 2.00 Lacs",
    "Rs. 2.00 Lacs - Rs. 5 Lacs",
    "Rs. 5 Lacs - Rs. 10 Lacs",
    "More than Rs. 10 Lacs",
  ];

  const getOvdValidationRule = (ovdType) => {
    switch (ovdType) {
      case "Passport":
        // 1 alphabet + 7 digits (Total 8)
        return {
          pattern: /^[A-Z]{1}[0-9]{7}$/,
          message:
            "Passport number must be 1 alphabet followed by 7 digits (Eg: Q2891324)",
        };

      case "VoterID":
        // 3 alphabets + 7 digits (Total 10)
        return {
          pattern: /^[A-Z]{3}[0-9]{7}$/,
          message:
            "Voter ID must be 3 alphabets followed by 7 digits (Eg: XBG0079731)",
        };

      case "Driving LIC":
        // 2 alphabets + 2 digits + space + 11 digits
        return {
          pattern: /^[A-Z]{2}[0-9]{2}\s[0-9]{11}$/,
          message: "Driving License format should be like TN10 12345678911",
        };

      case "NREGA Card No":
        // PB-10-011-001-001/72 (last part 2–5 digits)
        return {
          pattern: /^[A-Z]{2}-[0-9]{2}-[0-9]{3}-[0-9]{3}-[0-9]{3}\/[0-9]{2,5}$/,
          message: "NREGA Card format should be like PB-10-011-001-001/72",
        };

      default:
        return {};
    }
  };

  const renderDataTypes = (value, default_values, name, val, display_name) => {
    switch (value) {
      case "string":
        return (
          <span className="ant-input-group-wrapper">
            <span className="ant-input-wrapper ant-input-group">
              <input
                placeholder={`Enter ${display_name}`}
                type="text"
                className="ant-input"
                name={name}
                defaultValue={val === "undefined" ? "" : val}
                onChange={(e) => {
                  form.setFields([
                    {
                      name,
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </span>
          </span>
        );
      case "integer":
        return (
          <span className="ant-input-group-wrapper">
            <span className="ant-input-wrapper ant-input-group">
              <input
                placeholder={`Enter ${display_name}`}
                type="text"
                className="ant-input"
                name={name}
                defaultValue={val}
                onChange={(e) => {
                  form.setFields([
                    {
                      name,
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </span>
          </span>
        );
      case "dropdown":
        return (
          <Select
            defaultValue={val}
            placeholder={`Select ${display_name}`}
            onChange={(e) => {
              form.setFields([
                {
                  name,
                  value: e,
                },
              ]);
            }}
          >
            {default_values &&
              default_values.map(({ id, value }) => (
                <Option key={id} value={id}>
                  {value}
                </Option>
              ))}
          </Select>
        );
      case "checkbox":
        return (
          <Input
            placeholder={`Enter ${display_name}`}
            style={{ minWidth: "216px" }}
            onChange={(e) => {
              form.setFields([
                {
                  name,
                  value: e.target.checked,
                },
              ]);
            }}
          />
        );

      case "multicheckbox":
        return (
          <Input
            placeholder={`Enter ${display_name}`}
            style={{ minWidth: "216px" }}
            onChange={(e) => {
              form.setFields([
                {
                  name,
                  value: e.target.checked,
                },
              ]);
            }}
          />
        );
      default:
      // code block
    }
  };

  const copyPermanentToCommunication = () => {
    form.setFieldsValue({
      communication_address_line_1: form.getFieldValue("address_line_1"),
      communication_address_line_2: form.getFieldValue("address_line_2"),
      communication_address_line_3: form.getFieldValue("address_line_3"),
      communication_city: form.getFieldValue("city"),
      communication_state: form.getFieldValue("state"),
      communication_pincode: form.getFieldValue("pincode"),
    });
  };

  const renderProfileForm = () => {
    return (
      <Form
        onSubmitCapture={() => {
          form.validateFields().then((res) => {
            handleSubmit1();
          });
        }}
        form={form}
        name="step1"
        layout="vertical"
        className="modal-form"
        validateMessages={validateMessages1}
      >
        <Row>
          <Col span={16}>
            <div className="d-flex gap1">
              <Form.Item
                name="title"
                label="Title"
                className="titleItem"
                rules={[
                  {
                    required: true,
                    message: "Title is required",
                  },
                ]}
              >
                <Select
                  value="Mr"
                  style={{ width: 60 }}
                  onChange={(e) => {
                    form.setFields([
                      {
                        name: "title",
                        value: e,
                      },
                    ]);
                  }}
                >
                  <Option value="Mr">Mr</Option>
                  <Option value="Mrs">Mrs</Option>
                  <Option value="Miss">Miss</Option>
                  <Option value="Dr">Dr</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="first_name"
                label="First Name"
                className="nameItem"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter First Name"
                  maxLength={50}
                  onChange={(e) => {
                    form.setFields([
                      {
                        name: "first_name",
                        value: e.target.value,
                      },
                    ]);
                  }}
                />
              </Form.Item>
              <Form.Item
                name="middle_name"
                label="Middle Name"
                className="nameItem"
                // rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter Middle Name"
                  maxLength={50}
                  onChange={(e) => {
                    form.setFields([
                      {
                        name: "middle_name",
                        value: e.target.value,
                      },
                    ]);
                  }}
                />
              </Form.Item>
              <Form.Item
                name="last_name"
                label="Last Name"
                className="nameItem"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Enter Last Name"
                  maxLength={50}
                  onChange={(e) => {
                    form.setFields([
                      {
                        name: "last_name",
                        value: e.target.value,
                      },
                    ]);
                  }}
                />
              </Form.Item>
            </div>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  type: "email",
                  message: "Please provide valid email",
                },
                {
                  required: true,
                  message: "Please provide valid email",
                },
              ]}
            >
              <Input
                placeholder="Enter Email"
                style={{ width: 455 }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "email",
                      value: e.target.value,
                    },
                  ]);
                }}
                value={form.getFieldValue("email")}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row className="w85">
          <Col span={8}>
            <Form.Item
              label="DOB"
              name="dob"
              rules={[{ required: true, message: "Please Select dob." }]}
            >
              <DatePicker
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "dob",
                      value: e,
                    },
                  ]);
                }}
                format={["DD-MM-YYYY"]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Mobile Number"
              name="primary_phone"
              rules={[
                { required: true, message: "Please input valid phone number!" },
              ]}
            >
              <span className="ant-input-group-wrapper">
                <span className="ant-input-wrapper ant-input-group">
                  <span className="ant-input-group-addon">+91</span>
                  <input
                    placeholder="Enter Number"
                    maxlength="10"
                    type="text"
                    className="ant-input"
                    value={mobile}
                    onChange={(e) => {
                      if (new RegExp(/^[0-9]*$/).test(e.target.value)) {
                        setMobile(e.target.value);
                        form.setFields([
                          {
                            name: "primary_phone",
                            value: e.target.value,
                          },
                        ]);
                      } else if (e.target.value === "") {
                        setMobile(e.target.value);
                      }
                    }}
                  />
                </span>
              </span>
            </Form.Item>
          </Col>
        </Row>
        <Row className="w85">
          <Col span={8}>
            <Form.Item name="roles" label="Role" rules={[{ required: true }]}>
              <Select
                placeholder="Select Role"
                mode={"multiple"}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "roles",
                      value: e,
                    },
                  ]);
                  setRole(e);
                }}
              >
                {rolesData &&
                  rolesData
                    ?.filter((ele) => ele.role_name !== "Admin")
                    ?.map(({ id, role_name }) => (
                      <Option key={id} value={role_name}>
                        {role_name}
                      </Option>
                    ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="emp_id"
              label="Employee ID"
              rules={[{ required: true, message: "Employee ID is required" }]}
            >
              <Input
                placeholder="Enter Employee ID"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "emp_id",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="w85">
          <Col span={8}>
            <Form.Item
              name="gender"
              label="Gender"
              rules={[
                {
                  required: true,
                  message: "Gender is required",
                },
              ]}
            >
              <Select
                value="Male"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "gender",
                      value: e,
                    },
                  ]);
                }}
                placeholder="Select Gender"
              >
                <Option value="Male">Male</Option>
                <Option value="Female">Female</Option>
                <Option value="Others">Others</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="nationality"
              label="Nationality"
              rules={[
                {
                  required: true,
                  message: "Nationality is required",
                },
              ]}
            >
              <Select
                defaultValue="Indian"
                placeholder="Select Nationality"
                disabled
                options={[{ label: "Indian", value: "Indian" }]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="occupation"
              label="Occupation"
              rules={[
                {
                  required: true,
                  message: "Occupation is required",
                },
              ]}
            >
              <Input
                placeholder="Enter occupation"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "occupation",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="w85">
          <Col span={8}>
            <Form.Item
              name="address_line_1"
              label="Address Line 1"
              rules={[
                {
                  required: true,
                  message: "Address Line 1 is required",
                },
                {
                  max: 45,
                  message: "Address line 1 cannot exceed 45 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9.\/()<>\[\]{}@#&+-:;" ]+$/,
                  message: `Please enter valid address. Please use only alphabets, numbers, spaces, and these special characters: . / ( ) < > { } [ ] @ # & + - : ; ""`,
                },
              ]}
            >
              <Input
                placeholder="Enter Address Line 1"
                // disabled={props.selectedId}
                onKeyDown={(e) => {
                  // Block comma completely
                  if (e.key === ",") {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (pasted.includes(",")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "address_line_1",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="address_line_2"
              label="Address Line 2"
              rules={[
                {
                  required: true,
                  message: "Address Line 2 is required",
                },
                {
                  max: 45,
                  message: "Address line 2 cannot exceed 45 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9.\/()<>\[\]{}@#&+-:;" ]+$/,
                  message: `Please enter valid address. Please use only alphabets, numbers, spaces, and these special characters: . / ( ) < > { } [ ] @ # & + - : ; ""`,
                },
              ]}
            >
              <Input
                placeholder="Enter Address Line 2"
                // disabled={props.selectedId}
                onKeyDown={(e) => {
                  // Block comma completely
                  if (e.key === ",") {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (pasted.includes(",")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "address_line_2",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="address_line_3"
              label="Address Line 3"
              rules={[
                {
                  required: true,
                  message: "Address Line 3 is required",
                },
                {
                  max: 45,
                  message: "Address line 3 cannot exceed 45 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9.\/()<>\[\]{}@#&+-:;" ]+$/,
                  message: `Please enter valid address. Please use only alphabets, numbers, spaces, and these special characters: . / ( ) < > { } [ ] @ # & + - : ; ""`,
                },
              ]}
            >
              <Input
                placeholder="Enter Address Line 3"
                // disabled={props.selectedId}
                onKeyDown={(e) => {
                  // Block comma completely
                  if (e.key === ",") {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (pasted.includes(",")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "address_line_3",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="city"
              label="City"
              rules={[
                {
                  required: true,
                  message: "City is required",
                },
                {
                  max: 100,
                  message: "City cannot exceed 100 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9\s]+$/,
                  message: "State must not contain special characters",
                },
              ]}
            >
              <Input
                placeholder="Enter City"
                // disabled={props.selectedId}

                onChange={(e) => {
                  form.setFields([
                    {
                      name: "city",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="pincode"
              label="Pincode"
              rules={[
                {
                  required: true,
                  message: "Pincode is required",
                },
                {
                  pattern: /^[0-9]{6}$/,
                  message: "Pincode must be exactly 6 digits",
                },
              ]}
            >
              <Input
                placeholder="Enter Pincode"
                // disabled={props.selectedId}
                onKeyDown={(e) => {
                  // Allow only numbers, backspace, delete, arrows, tab
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (!/^[0-9]+$/.test(pasted)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "pincode",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="state"
              label="State"
              rules={[
                {
                  required: true,
                  message: "State is required",
                },
                {
                  max: 100,
                  message: "State cannot exceed 100 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9\s]+$/,
                  message: "State must not contain special characters",
                },
              ]}
            >
              <Input
                placeholder="Enter State"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "state",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="w85"></Row>
        <Row className="mb1">
          <Col span={9.5}>
            <Checkbox
              checked={sameAsPermanent}
              onChange={(e) => {
                const checked = e.target.checked;
                setSameAsPermanent(checked);

                if (checked) {
                  copyPermanentToCommunication();
                }
              }}
            >
              Communication address same as permanent address
            </Checkbox>
          </Col>
        </Row>
        <Row className="w85">
          <Col span={8}>
            <Form.Item
              name="communication_address_line_1"
              label="Communication Address Line 1"
              rules={[
                {
                  required: true,
                  message: "Communication Address Line 1 is required",
                },
                {
                  max: 45,
                  message:
                    "Communication address line 1 cannot exceed 45 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9.\/()<>\[\]{}@#&+-:;" ]+$/,
                  message: `Please enter valid address. Please use only alphabets, numbers, spaces, and these special characters: . / ( ) < > { } [ ] @ # & + - : ; ""`,
                },
              ]}
            >
              <Input
                placeholder="Enter Communication Address Line 1"
                disabled={sameAsPermanent}
                onKeyDown={(e) => {
                  // Block comma completely
                  if (e.key === ",") {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (pasted.includes(",")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "communication_address_line_1",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="communication_address_line_2"
              label="Communication Address Line 2"
              rules={[
                {
                  required: true,
                  message: "Communication Address Line 2 is required",
                },
                {
                  max: 45,
                  message:
                    "Communication address line 2 cannot exceed 45 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9.\/()<>\[\]{}@#&+-:;" ]+$/,
                  message: `Please enter valid address. Please use only alphabets, numbers, spaces, and these special characters: . / ( ) < > { } [ ] @ # & + - : ; ""`,
                },
              ]}
            >
              <Input
                placeholder="Enter Communication Address Line 2"
                disabled={sameAsPermanent}
                onKeyDown={(e) => {
                  // Block comma completely
                  if (e.key === ",") {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (pasted.includes(",")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "communication_address_line_2",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="communication_address_line_3"
              label="Communication Address Line 3"
              rules={[
                {
                  required: true,
                  message: "Address Line 3 is required",
                },
                {
                  max: 45,
                  message:
                    "Communication address line 3 cannot exceed 45 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9.\/()<>\[\]{}@#&+-:;" ]+$/,
                  message: `Please enter valid address. Please use only alphabets, numbers, spaces, and these special characters: . / ( ) < > { } [ ] @ # & + - : ; ""`,
                },
              ]}
            >
              <Input
                placeholder="Enter Communication Address Line 3"
                disabled={sameAsPermanent}
                onKeyDown={(e) => {
                  // Block comma completely
                  if (e.key === ",") {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (pasted.includes(",")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "communication_address_line_3",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="communication_city"
              label="Communication City"
              rules={[
                {
                  required: true,
                  message: "Communication City is required",
                },
                {
                  max: 100,
                  message: "Communication City cannot exceed 100 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9\s]+$/,
                  message:
                    "Communication City must not contain special characters",
                },
              ]}
            >
              <Input
                placeholder="Enter Communication City"
                disabled={sameAsPermanent}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "communication_city",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="communication_pincode"
              label="Communication Pincode"
              rules={[
                {
                  required: true,
                  message: "Communication Pincode is required",
                },
                {
                  pattern: /^[0-9]{6}$/,
                  message: "Communication Pincode must be exactly 6 digits",
                },
              ]}
            >
              <Input
                placeholder="Enter Communication Pincode"
                disabled={sameAsPermanent}
                onKeyDown={(e) => {
                  // Allow only numbers, backspace, delete, arrows, tab
                  if (
                    !/[0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData("text");
                  if (!/^[0-9]+$/.test(pasted)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "communication_pincode",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="communication_state"
              label="Communication State"
              rules={[
                {
                  required: true,
                  message: "Communication State is required",
                },
                {
                  max: 100,
                  message: "Communication State cannot exceed 100 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9\s]+$/,
                  message:
                    "Communication State must not contain special characters",
                },
              ]}
            >
              <Input
                placeholder="Enter Communication State"
                disabled={sameAsPermanent}
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "communication_state",
                      value: e.target.value,
                    },
                  ]);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="w85">
          <Col span={6}>
            <Form.Item
              name="kyc_type"
              label="KYC Type"
              rules={[{ required: true }]}
            >
              <Select
                // defaultValue="MIN"
                placeholder="Select"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "kyc_type",
                      value: e,
                    },
                  ]);
                }}
              >
                <Option value="MIN" defaultValue>
                  {"MIN"}
                </Option>
                <Option value="FULL" disabled>
                  {"FULL"}
                </Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="kyc_method"
              label="KYC Method"
              rules={[{ required: true }]}
            >
              <Select
                // defaultValue="OVD"
                placeholder="Select"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "kyc_method",
                      value: e,
                    },
                  ]);
                }}
              >
                <Option value="OVD">{"OVD"}</Option>
                <Option value="Biometric" disabled>
                  {"Biometric"}
                </Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="ovd_type"
              label="OVD Type"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select"
                onChange={(e) => {
                  form.setFields([
                    {
                      name: "ovd_type",
                      value: e,
                    },
                  ]);
                }}
              >
                <Option value="PASSPORT">{"Passport"}</Option>
                <Option value="DRIVING_LICENSE">{"Driving License"}</Option>
                <Option value="VOTER_ID">{"Voter ID"}</Option>
                <Option value="NREGA_CARD_NO">{"NREGA Card No"}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              shouldUpdate={(prev, curr) => prev.ovd_type !== curr.ovd_type}
              noStyle
            >
              {({ getFieldValue }) => {
                const ovdType = getFieldValue("ovd_type");
                const ovdRule = getOvdValidationRule(ovdType);

                return (
                  <Form.Item
                    name="ovd_details"
                    label="OVD Details"
                    rules={[
                      { required: true, message: "OVD Details is required" },
                      ovdRule,
                    ]}
                  >
                    <Input
                      placeholder="Enter OVD Details"
                      onChange={(e) => {
                        form.setFields([
                          {
                            name: "ovd_details",
                            value: e.target.value.toUpperCase(),
                          },
                        ]);
                      }}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        {/* <Row className="w91">
          <Col span={8}>
            <Form.Item name="project_id" label="Project">
              <Select
                placeholder="Select Project"
                onChange={(val) => handleDesignation(val)}
                value={form.getFieldValue("project_id")}
              >
                {projectsResponse &&
                  projectsResponse.map(({ id, name }) => (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8} className="ml1">
            <Form.Item name="cost_center_id" label="Cost center">
              <Select
                placeholder="Select Cost center"
                value={form.getFieldValue("cost_center_id")}
              >
                {costCentersResponse &&
                  costCentersResponse.map(({ id, name }) => (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row> */}
        <Row className="w85">
          {/* <Col span={8}>
            <Form.Item
              name="customer_type"
              label="Customer Type"
              rules={[
                {
                  required: true,
                  message: "Customer Type is required",
                },
              ]}
            >
              <Select
                defaultValue="Individual"
                placeholder="Select Customer Type"
                disabled
                options={[{ label: "Individual", value: "Individual" }]}
              />
            </Form.Item>
          </Col> */}
          {approversData &&
            approversData.map(({ name, options, selected }, index) => {
              return (
                <Col span={8} key={index}>
                  <Form.Item
                    name={name}
                    label={name}
                    className="dynamicValues"
                    // rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Approver"
                      value={selected.id}
                      onChange={(e) => {
                        form.setFields([
                          {
                            name,
                            value: e,
                          },
                        ]);
                      }}
                    >
                      {options &&
                        options.map(({ id, name }) => (
                          <Option key={id} value={id}>
                            {name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              );
            })}
        </Row>
        <Row className="width-80">
          {advanceApproversData &&
            advanceApproversData.map(({ name, options }, index) => (
              <Col span={8} key={index}>
                <Form.Item
                  name={name}
                  label={name}
                  className="dynamicValues"
                  // rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Select Advance Approver"
                    onChange={(e) => {
                      form.setFields([
                        {
                          name,
                          value: e,
                        },
                      ]);
                    }}
                  >
                    {options &&
                      options.map(({ id, name }) => (
                        <Option key={id} value={id}>
                          {name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            ))}
        </Row>
        <Row className="w85">
          {userfieldsData &&
            userfieldsData.map(
              ({
                field_id,
                display_name,
                is_required,
                column_type,
                default_values,
                selected,
              }) => (
                <Col span={8} key={field_id}>
                  <Form.Item
                    name={field_id}
                    label={display_name}
                    className="dynamicValues"
                    rules={
                      column_type === "integer"
                        ? [
                            {
                              required: is_required,
                              message: `${display_name} is required`,
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: " Only Numbers are allowed",
                            },
                          ]
                        : [
                            {
                              required: is_required,
                              message: `${display_name} is required`,
                            },
                          ]
                    }
                  >
                    {renderDataTypes(
                      column_type,
                      default_values,
                      field_id,
                      selected?.value,
                      display_name,
                    )}
                  </Form.Item>
                </Col>
              ),
            )}
        </Row>

        <Button
          key="1"
          className="formButton mt1 primaryButton"
          htmlType="submit"
        >
          Next
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => {
            form.resetFields();
            props.handleAdd();
          }}
        >
          Cancel
        </Button>
      </Form>
    );
  };

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`New User`}
          navigation={{
            "Enter user details and submit": "",
          }}
        />
      </div>
      <Tabs
        activeKey={activeTab}
        type="card"
        size="large"
        className="setting-tabs"
      >
        <TabPane tab={tabTitle.profile()} key="profile">
          {renderProfileForm()}
        </TabPane>
        <TabPane tab={tabTitle.limits()} key="limits">
          <Form form={form} layout="vertical" className="modal-form">
            <Row>
              <Col span={6}>
                <Form.Item name="designation" label="Designation">
                  <Select
                    placeholder="Select Designation"
                    onChange={(val) => handleDesignation(val)}
                  >
                    {designationsData &&
                      designationsData.map(({ id, title }) => (
                        <Option key={id} value={id}>
                          {title}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6} className="ml1">
                <Form.Item name="grade_id" label="Grade/Level">
                  <Select
                    placeholder="Select Grade/Level"
                    disabled={!form.getFieldValue("designation")}
                  >
                    {gradesData &&
                      gradesData.map(({ id, level }) => (
                        <Option key={id} value={id}>
                          {level}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {/* <Row>
              <Checkbox>
                Enabled Expense limit based on his designation
              </Checkbox>
            </Row>
            <Row>
              <Table
                rowKey="id"
                columns={[...columns]}
                dataSource={data}
                className="settingsTable mt1"
              />
            </Row> */}
            <Button
              key="3"
              className="formButton mt1 primaryButton"
              onClick={() => handleSubmit2()}
            >
              Next
            </Button>
            <Button
              key="55"
              className="cancelButton ml1 mt1"
              onClick={() => handleBackButton("screen1")}
            >
              Back
            </Button>
            <Button
              key="4"
              className="cancelButton ml1 mt1"
              onClick={() => {
                form.resetFields();
                props.handleAdd();
              }}
            >
              Cancel
            </Button>
          </Form>
        </TabPane>
        <TabPane tab={tabTitle.card()} key="card">
          <Form form={form} layout="vertical" className="modal-form">
            <Row>
              <Checkbox checked={checkedValue} onChange={(e) => handleCheck(e)}>
                Want to give a card to this user
              </Checkbox>
              <Col span={24} className="mt1">
                <Form.Item name="card_number" label="Card Number or KIT number">
                  <Input
                    placeholder="Enter Card Number"
                    disabled={!checkedValue}
                  />
                </Form.Item>
              </Col>
              {/* <Checkbox>Skip Invitation email</Checkbox> */}
            </Row>
            <Button
              key="5"
              className="formButton mt3 primaryButton"
              onClick={() => handleSubmit3()}
              disabled={
                addEmployeesResponse?.loading ||
                updateEmployeesResponse?.loading
              }
            >
              Save
            </Button>
            <Button
              key="66"
              className="cancelButton ml1 mt1"
              onClick={() => handleBackButton("screen2")}
            >
              Back
            </Button>
            <Button
              key="6"
              className="cancelButton ml1 mt3"
              onClick={() => {
                form.resetFields();
                props.handleAdd();
              }}
            >
              Cancel
            </Button>
          </Form>
        </TabPane>
      </Tabs>
    </>
  );
};

export default AddUsers;
